module.exports = __webpack_public_path__ + "assets/img/100704.19cad001.svg";